import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import "@tento-ui/components/round";
import { Button } from "@tento-ui/components/button/button";
import { GESTURE_MANAGER } from "@tento-ui/gesture-manager";
import { DateTime, Utc } from "@tento-chrono";
import { Round } from "@tento-ui/components/round";

@component({
  name: "lona-grace-period-banner",
})
export class GracePeriodBanner extends LonaWebComponent {
  $bg = this.hydrate<Round>("bg").bind(Round.Props.FLAT_CARD);

  onUpgrade?: () => void;

  constructor() {
    super();
    GESTURE_MANAGER.addPointerEvent(this.$("upgrade-btn"), {
      onClick: () => this.onUpgrade?.(),
    });
  }

  bind(_graceExpiresAt: DateTime<Utc>): this {
    return this;
  }

  static $styles = [
    Button.$style,
    css`
      :host {
        display: block;
        margin-top: 2px;
      }

      #inner {
        padding: 12px;
      }

      #body {
        color: var(--text-sec);
        --margin-top: 0px;
        --margin-bottom: 0px;
      }

      #upgrade-btn {
        width: 100%;
        margin-top: auto;
      }

      #content {
        padding: 4px 8px;
        margin-bottom: 8px;
      }
    `,
  ];
  static $html: Option<HTMLTemplateElement> = html`
    <std-round id=bg>
      <std-col id="inner">
        <div id=content>
          <p id="body">Ready to keep building your calendar surface? Upgrade to keep planning without limits.</p>
        </div>
        <button id="upgrade-btn" primary>Upgrade →</button>
      </std-col>
    </std-round>
  `;
}
